import { SourceBasedExpression } from '../Expression.js';
export class NotEmptyExpression extends SourceBasedExpression {
    evaluate(visitor, localVariables) {
        const source = this.getSource().evaluate(visitor, localVariables);
        return Array.isArray(source) ? source.length !== 0 : false;
    }
}
//# sourceMappingURL=NotEmptyExpression.js.map